import { actionTypeCreator, SYNC } from 'lib/redux-utils';
import { NAME } from './constants';

const namespace = actionTypeCreator(NAME);

export const T = namespace({
  LOCATION_CHANGE: SYNC,
  CALL_HISTORY_METHOD: SYNC
});
